<script setup>
/* eslint-disable */
import { watch, ref, onBeforeUnmount } from "vue";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

const props = defineProps({
  chartData: {
    type: Array,
    required: true,
  },
});

let chart = null;

const createChart = (data) => {
  if (!data || !data.length) return;

  am4core.useTheme(am4themes_animated);

  chart = am4core.create("chartdiv", am4charts.XYChart);
  chart.colors.step = 2;
  chart.maskBullets = false;
  chart.data = data;

  let dateAxis = chart.xAxes.push(new am4charts.DateAxis());
  dateAxis.renderer.minGridDistance = 50;
  dateAxis.renderer.fullWidthTooltip = true;
  dateAxis.dateFormats.setKey("day", "yyyy/MM/dd");
  dateAxis.periodChangeDateFormats.setKey("day", "yyyy/MM/dd");

  // Rotate the labels
dateAxis.renderer.labels.template.rotation = -50;  // Rotate labels by -45 degrees (adjust as needed)
dateAxis.renderer.labels.template.horizontalCenter = "right";  // Align horizontally to the right
dateAxis.renderer.labels.template.verticalCenter = "middle";  // Align vertically to the middle

// Reduce the font size
dateAxis.renderer.labels.template.fontSize = 14;  // Adjust the font size as needed

  let distanceAxis = chart.yAxes.push(new am4charts.ValueAxis());
  distanceAxis.title.text = "Values";

  // Yellow Bars
  let distanceSeries = chart.series.push(new am4charts.ColumnSeries());
  distanceSeries.dataFields.valueY = "overtime";
  distanceSeries.dataFields.dateX = "date";
  distanceSeries.name = "OVERTIME REQUEST";
  distanceSeries.tooltipText = "OVERTIME REQUEST {valueY}";
  distanceSeries.columns.template.fill = am4core.color("#efac00");
  distanceSeries.columns.template.stroke = am4core.color("#efac00");
  distanceSeries.columns.template.fillOpacity = 0.8;

  // Blue Line
  let durationSeries = chart.series.push(new am4charts.LineSeries());
  durationSeries.dataFields.valueY = "onTime";
  durationSeries.dataFields.dateX = "date";
  durationSeries.name = "ON TIME OFFICERS";
  durationSeries.strokeWidth = 2;
  durationSeries.stroke = am4core.color("#468af6");
  durationSeries.tooltipText = "ON TIME OFFICERS {valueY}";

  durationSeries.tooltip.getFillFromObject = false;
  durationSeries.tooltip.background.fill = am4core.color("#468af6");
  durationSeries.tooltip.label.fill = am4core.color("#ffffff"); // white text for contrast

  let durationBullet = durationSeries.bullets.push(new am4charts.CircleBullet());
  durationBullet.circle.fill = am4core.color("#468af6");
  durationBullet.circle.strokeWidth = 2;

  // Black Line
  let metric3Series = chart.series.push(new am4charts.LineSeries());
  metric3Series.dataFields.valueY = "lateTime";
  metric3Series.dataFields.dateX = "date";
  metric3Series.name = "LATE OFFICERS";
  metric3Series.strokeWidth = 2;
  metric3Series.stroke = am4core.color("#00368c");
  metric3Series.tooltipText = "LATE OFFICERS {valueY}";

  metric3Series.tooltip.getFillFromObject = false;
  metric3Series.tooltip.background.fill = am4core.color("#00368c");
  metric3Series.tooltip.label.fill = am4core.color("#ffffff"); // white text for contrast

  let metric3Bullet = metric3Series.bullets.push(new am4charts.CircleBullet());
  metric3Bullet.circle.fill = am4core.color("#00368c");
  metric3Bullet.circle.strokeWidth = 2;

  // Purple Line
  let metric4Series = chart.series.push(new am4charts.LineSeries());
  metric4Series.dataFields.valueY = "absentTime";
  metric4Series.dataFields.dateX = "date";
  metric4Series.name = "ABSENTS OFFICERS";
  metric4Series.strokeWidth = 2;
  metric4Series.stroke = am4core.color("#9747ff");
  metric4Series.tooltipText = "ABSENTS OFFICERS {valueY}";

  metric4Series.tooltip.getFillFromObject = false;
  metric4Series.tooltip.background.fill = am4core.color("#9747ff");
  metric4Series.tooltip.label.fill = am4core.color("#ffffff"); // white text for contrast

  let metric4Bullet = metric4Series.bullets.push(new am4charts.CircleBullet());
  metric4Bullet.circle.fill = am4core.color("#9747ff");
  metric4Bullet.circle.strokeWidth = 2;

  chart.legend = new am4charts.Legend();
  chart.cursor = new am4charts.XYCursor();
  chart.logo.disabled = true;
};

// Watch for props.chartData to be ready
watch(
  () => props.chartData,
  (newData) => {
    if (chart) {
      chart.dispose(); // clean previous chart if any
    }
    createChart(newData);
  },
  { immediate: true }
);

onBeforeUnmount(() => {
  if (chart) {
    chart.dispose();
  }
});
</script>

<template>
  <div id="chartdiv" style="width: 100%; height: 500px"></div>
</template>
